module.exports = __webpack_public_path__ + "static/media/notification_bell.ac8d93f6.svg";